export type GeneralConfigSectionKey =
  | "general-config-users"
  | "general-config-history-balance"
  | "general-config-terms"
  | "general-config-configurations";

export type GeneralConfigSection = {
  key: GeneralConfigSectionKey;
  label: string;
  path: string;
};

export const GENERAL_CONFIG_SECTIONS: GeneralConfigSection[] = [
  {
    key: "general-config-users",
    label: "User Management",
    path: "/general-configuration/user-management",
  },
  {
    key: "general-config-history-balance",
    label: "History Balance",
    path: "/general-configuration/history-balance",
  },
  {
    key: "general-config-terms",
    label: "Terms and Conditions",
    path: "/general-configuration/terms-and-conditions",
  },
  {
    key: "general-config-configurations",
    label: "Configurations",
    path: "/general-configuration/configurations",
  },
];

export const DEFAULT_GENERAL_CONFIG_ORDER: GeneralConfigSectionKey[] =
  GENERAL_CONFIG_SECTIONS.map((section) => section.key);
